module.exports = __webpack_public_path__ + "img/frame (157).c8ae5126.jpg";